import { render, staticRenderFns } from "./wang-editor-custom.vue?vue&type=template&id=e0b182f6"
import script from "./wang-editor-custom.vue?vue&type=script&lang=js"
export * from "./wang-editor-custom.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./wang-editor-custom.vue?vue&type=style&index=1&id=e0b182f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports